import { Skeleton } from '@mui/material'

const ArticleNameSkeleton: React.FC = () => {
  return <Skeleton width={350} />
}

export default ArticleNameSkeleton
